import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mmm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("mmm_token");
      if (!window.location.pathname.match(/^\/(login|forgot-password|reset-password|setup|)$/)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Authenticated file download/open (blob) — for protected document endpoints.
export const downloadFile = async (path, filename = "document") => {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
};

// Normalize an axios error into a safe, human-readable string (handles FastAPI 422 detail arrays).
export const errMsg = (err, fallback = "Something went wrong. Please try again.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join("; ") || fallback;
  if (d && typeof d === "object") return d.msg || fallback;
  return err?.message || fallback;
};
